import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Field} from 'formik';
import styles from './styles.module.scss';
import markFilledInput from '../../assets/markFilledInput.svg';

const FieldTextarea = ({
                         fieldId,
                         label = null,
                         showBird = true,
                         containerCustomStyles = null, // deprecated, legacy usage only
                         classNames: classNamesProp = {},
                       }) => {
  const classNames = {
    container: containerCustomStyles,
    ...classNamesProp
  };

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({field, meta}) => (
        <label
          className={classnames(styles.textareaContainer, classNames.container)}>
          <div
            className={classnames(styles.labelContainer, classNames.label, {
              [styles.errorLabel]: meta.error && meta.touched
            })}
          >
            {label}
            <div
              className={classnames(styles.markFilledInputOff, {
                [styles.markFilledInputOn]: !meta.error && meta.touched && meta.value && showBird
              })}>
              <img
                src={markFilledInput}
                alt="markFilledInput"
              />
            </div>
          </div>
          <textarea
            className={classnames(styles.textarea, classNames.input, {
              [styles.errorBorder]: meta.error && meta.touched
            })}
            {...field}
          />
          <div
            className={classnames(styles.errorMessageOff, {[styles.errorMessageOn]: meta.error && meta.touched})}>
            <p className={styles.errorText}>{meta.error}</p>
          </div>
        </label>
      )}
    </Field>
  );
};

FieldTextarea.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  label: PropTypes.node,
  labelStyles: PropTypes.object,
  classNames: PropTypes.shape({
    input: PropTypes.string,
    label: PropTypes.string,
    container: PropTypes.string,
  })
};

export default FieldTextarea;
